import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import Notification, { showToast } from '../../../components/common/notification/Notification';
import Spinner from '../../../components/common/spinner/Spinner';
import BreadCrumb from '../../components/breadcrumb/BreadCrumb';
import List from '../../components/listing/List';
import { Container, Row, Col } from 'react-bootstrap';

const HelpCenter = () => {
  const loggedInUser = useSelector((state) => state.auth.user);
  console.log("loggedInUser: ", loggedInUser);
  const userId = loggedInUser?.user?.id;

  console.log("loggedInUser ID: ", userId)
  const token = loggedInUser?.refreshToken;
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [helpRequests, setHelpRequests] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  // If deletion is required
  const handleDelete = async (itemId) => {
    try {
      const response = await axios.delete(
        `${baseUrl}/admin/deleteContactUs/${itemId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response)
      if (response.data.statusType === 'SUCCESS') {
        setHelpRequests(helpRequests.filter((item) => item.id !== itemId));
        showToast('Help Request deleted successfully', { type: 'success' });
      } else {
        showToast('Failed to delete request', { type: 'error' });
      }
    } catch (error) {
      console.error('Error deleting help request:', error);
      showToast('Error occurred during deletion', { type: 'error' });
    }
  };

  const columns = [
    { displayName: "S.No.", render: (item, index) => ((currentPage-1)*10) + index + 1 },
    { displayName: 'Name', key: 'name' },
    { displayName: 'Email Address', key: 'email_address' },
    { displayName: 'Mobile Number', key: 'mobile_number' },
    { displayName: 'Message', key: 'message' },
  ];

  const breadcrumbItems = [
    { label: '', link: '/', icon: 'fa-solid fa-house' },
    { label: 'Help Center', link: '/help-center', active: true },
  ];

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await axios.post(
        `${baseUrl}/admin/listContactUs`,
        {
          page_number: currentPage,
          page_size: 20,
          order_by: 'ASC',
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response.data)

      if (response.status === 200 && response.data.statusType === 'SUCCESS') {
        setHelpRequests(response.data.contactUss || []); 
        setTotalPages(response.data.totalPages || 1);
      } else {
        showToast('Failed to fetch help center data', { type: 'error' });
      }
    } catch (error) {
      setIsError(true);
      console.error('Fetch error:', error);
      showToast('Error fetching help center data', { type: 'error' });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <>
      <Notification />

      <div className="bread-crumb">
        <Container>
          <Col md={8} >
            <BreadCrumb items={breadcrumbItems} />
          </Col>
        </Container>
      </div>
      <div className="pt-4 content-body w-100">
        <Row className='d-flex justify-content-center'>
          <Col md={8} className="mb-5 d-flex align-items-center ">
            {isLoading ? (
              <Spinner loading={true} />
            ) : (
              <List
                title="Help Center"
                data={helpRequests}
                columns={columns}
                button={false}
                route={loggedInUser.user.userType.name === "SUPER_ADMIN" ?  "" : "help-center"}
                // route="help-center"
                // to="add-help-center"
                handleDelete={handleDelete}
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            )}
          </Col>
        </Row>
      </div>
    </>
  );
};

export default HelpCenter;

